import { Injectable } from '@angular/core';
import * as FullStory from '@fullstory/browser';
import { getActionTypeFromInstance, NgxsNextPluginFn, NgxsPlugin } from '@ngxs/store';

/** Capture every actions dispated by the store and record them in FullStory event stream. */
@Injectable()
export class MonitoringMetaReducer implements NgxsPlugin {
  handle(state: any, action: any, next: NgxsNextPluginFn) {
    const eventName = getActionTypeFromInstance(action);
    // Filter built-in actions, load actions and notification actions.
    if (!eventName.startsWith('@@')
      && !eventName.includes('Load')
      && !eventName.includes('SetSelected')
      && !eventName.includes('[Notifications]')
    ) {
      const eventProps = Object.entries(action)
        // Filter empty properties.
        .filter(([_, value]) => !!value)
        .reduce((props, [key, value]) => ({ ...props, [key]: value }), {});

      FullStory.event(eventName, eventProps);
    }
    return next(state, action);
  }
}
